import { h } from "@stencil/core";
import { createErrorMessage } from "./utils";
export function toSingleError(error, value, initialValue) {
    if (error === null || error === undefined) {
        return {};
    }
    if (typeof value === 'object') {
        if (JSON.stringify(value) !== JSON.stringify(initialValue)) {
            return {};
        }
    }
    else if (value !== initialValue) {
        return {};
    }
    if (typeof error === 'string') {
        return { '': error };
    }
    return error;
}
export class RenderInfo {
    constructor(parent = null) {
        this.parent = parent;
        this.singleInputRenderers = {};
    }
    getAvailabeInputTypes() {
        const list = Object.keys(this.singleInputRenderers);
        if (this.parent) {
            list.push(...this.parent.getAvailabeInputTypes());
        }
        return new Set(list);
    }
    createFieldWrapper() {
        return (content) => content;
    }
    getSingleInputRenderer(types) {
        for (let type of types) {
            if (this.singleInputRenderers[type]) {
                return this.singleInputRenderers[type];
            }
        }
        if (!this.parent) {
            throw new Error('No input renderer found for type: ' + types.join(', '));
        }
        return this.parent.getSingleInputRenderer(types);
    }
    renderSingleInput(types, input) {
        return this.getSingleInputRenderer(types)(input);
    }
    renderSubmitButton(state) {
        return h("input", { type: "submit", disabled: state.disabled, value: state.label });
    }
    renderFormGroup(state, subElements, key = null) {
        return h("div", { style: { width: '100%' }, key: key !== null && key !== void 0 ? key : state.name }, subElements);
    }
    renderValidationError(state, value) {
        const errorMessage = createErrorMessage(state, value);
        if (errorMessage) {
            return h("div", { style: { color: state.serverSide ? 'red' : 'black' } }, "\u274C ", errorMessage);
        }
        return state.serverSide ? [] : h("div", { style: { color: 'green' } }, "\u2705 ", errorMessage);
    }
    renderUnmappedErrors(unmapped, validationErrors) {
        if (typeof validationErrors === 'string') {
            return this.renderValidationError({
                fieldType: 'constraint',
                inverseCheck: false,
                exactMatch: undefined,
                message: validationErrors,
                serverSide: true,
            }, undefined);
        }
        const errors = [];
        for (let error of unmapped) {
            const res = this.renderValidationError({
                fieldType: 'constraint',
                inverseCheck: false,
                exactMatch: undefined,
                message: validationErrors[error],
                serverSide: true,
            }, undefined);
            if (Array.isArray(res)) {
                errors.push(...res);
            }
            else {
                errors.push(res);
            }
        }
        return errors;
    }
    renderListOrMapRow(state, subElement) {
        return h("div", { style: { width: '100%' }, key: state.mappingKey }, subElement, state.onRowRemove && h("button", { type: "button", onClick: () => state.onRowRemove() }, "X"));
    }
    renderAddItemToList(state) {
        return h("button", { type: "button", disabled: state.disabled, onClick: () => state.onRowAdd() }, "Add");
    }
    renderAddItemToMap(keyField, button) {
        return [
            ...(Array.isArray(keyField) ? keyField : [keyField]),
            ...(Array.isArray(button) ? button : [button])
        ];
    }
}
//# sourceMappingURL=RenderInfo.js.map
